import { HTMLProps, useState } from 'react';
import cx from 'classnames';

import { Color } from 'components';

import styles from './Avatar.module.scss';

export type AvatarProps = Pick<HTMLProps<HTMLDivElement>, 'className'> & {
  fallbackColor: string;
  initials?: string;
  src?: string;
};

const Avatar = ({ className, src, fallbackColor, initials }: AvatarProps) => {
  const [imageLoadError, setImageLoadError] = useState(false);

  const handleOnImageLoadError = () => setImageLoadError(true);

  return (
    <div className={cx(styles.container, className)}>
      {src && !imageLoadError ? (
        <img src={src} alt="speaker" onError={handleOnImageLoadError} />
      ) : (
        <Color color={fallbackColor} className={styles.color}>
          {initials && <span>{initials}</span>}
        </Color>
      )}
    </div>
  );
};

export default Avatar;
